<template>
  <el-dialog
    :title="toggleProductStateInfo.actionText + '商品'"
    :visible.sync="dialogVisible"
    width="480px"
    @close="closeDialog"
  >
    <p>确认{{ toggleProductStateInfo.actionText }}商品「{{ toggleProductStateInfo.prodName }}」吗？</p>
    <el-form label-width="180px" style="margin-top: 16px;">
      <el-form-item label="同步时商品自动上下架">
        <el-radio-group v-model="toggleProductStateInfo.syncAutoShelfOn">
          <el-radio :label="true">开启</el-radio>
          <el-radio :label="false">关闭</el-radio>
        </el-radio-group>
        <div class="form-tip">
          开启后允许第三方同步库存时根据库存自动修改上下架；关闭后将锁定上下架状态，同步时不再自动修改上下架。
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" :loading="submitting" @click="confirmToggleProductState">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateProductState } from '@/api/goods/productApi'

export default {
  name: 'ToggleProductState',
  data() {
    return {
      dialogVisible: false,
      submitting: false,
      toggleProductStateInfo: {
        productId: '',
        prodName: '',
        state: '',
        targetState: '',
        actionText: '',
        syncAutoShelfOn: true
      }
    }
  },
  methods: {
    open(product) {
      const isOnShelf = product.state === '2002'
      const syncStateLock = product.syncStateLock
      this.toggleProductStateInfo = {
        productId: product.productId,
        prodName: product.prodName,
        state: product.state,
        targetState: isOnShelf ? '1001' : '2002',
        actionText: isOnShelf ? '下架' : '上架',
        syncAutoShelfOn: syncStateLock != '2002'
      }
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
    },
    async confirmToggleProductState() {
      this.submitting = true
      try {
        const res = await updateProductState({
          productId: this.toggleProductStateInfo.productId,
          state: this.toggleProductStateInfo.targetState,
          syncAutoShelfOn: !!this.toggleProductStateInfo.syncAutoShelfOn
        })
        if (res.code === 0) {
          this.$message.success(`${this.toggleProductStateInfo.actionText}成功`)
          this.dialogVisible = false
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg || `${this.toggleProductStateInfo.actionText}失败`)
        }
      } catch (error) {
        console.error('上下架失败:', error)
        this.$message.error(`${this.toggleProductStateInfo.actionText}失败`)
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.form-tip {
  margin-top: 8px;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}
</style>
